export default __webpack_public_path__ + "static/media/IMG-20210701-WA0060.99c18cf5.jpg";